import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'kia-model',
  shadow: true,
  styleUrl: 'model.scss',
})
export class KiaModel {
  @Prop() code: string;

  render() {
    return (
      <div class="kia_model">
        <kia-filters />
        <kia-priskort code={this.code} />
      </div>
    );
  }
}
